<template>
  <div>
    <van-nav-bar :title="t('menus.VipActivity')" :border="false" class="custom-nav-bar nav-bar-fixed sticky-nav">
      <template #left>
        <Button type="back" @click="onClickLeft" />
      </template>
    </van-nav-bar>
    <div class="content-container">
      <div class="w-full px-[10px]">
        <img :src="getAssetsFile('home/vipckc.png')" alt="" class="w-full" style="object-fit: cover;">
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { Button } from "@/components/Button"
const router = useRouter()
const { t } = useI18n()

const onClickLeft = () => router.back()
</script>

<style lang="scss" scoped>
.custom-nav-bar {
  height: 56px;
  box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.3), 0px -2px 22px 0px rgba(53,189,128,0.61);
  &>* {
    height: 100%;
  }
}
.sticky-nav {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.content-container {
  margin-top: 46px;
}
</style>

<route lang="json5">
{
  name: 'VipActivity',
  meta: {
    title: 'VipActivity',
    i18n: 'menus.VipActivity'
  },
}
</route>
